// extracted by mini-css-extract-plugin
export var actionButton = "_9d-0";
export var attachmentLine = "_9d-1";
export var fileInput = "_9d-2";
export var fileUploadWrapper = "_9d-4";
export var footer = "_9d-3";
export var modalContent = "_9d-5";
export var paperclip = "_9d-6";
export var quillEditor = "_9d-7";